@if (
  authServ.isUser.value &&
  !authServ.isScreen.value &&
  !isAgentsOrdersRoute() &&
  !isClientOrdersRoute() &&
  authServ.permissionUsed.value !== helpers.PermisionManufacturer
) {
  <div>
    @if (!isWarehouseOrdersRoute()) {
      <app-sidebar></app-sidebar>
    }
    <!--<app-right-sidebar></app-right-sidebar>-->
  </div>
}

<div
  [class.home-closed]="
    !sidebarService.isOpen && !isAgentsOrdersRoute() && !isClientOrdersRoute()
  "
  [class.home]="
    sidebarService.isOpen &&
    !isAgentsOrdersRoute() &&
    !isClientOrdersRoute() &&
    authServ.permissionUsed.value !== helpers.PermisionManufacturer
  "
  [class.manufacturer-layout]="
    authServ.permissionUsed.value === helpers.PermisionManufacturer
  "
  [class.footer-fullwidth]="!authServ.isUser.value"
  [class.setWarehouseWidthScreen]="
    authServ.isScreen.value ||
    authServ.permissionUsed.value === helpers.PermisionManufacturer
  "
>
  <!-- [class.AgentHome]="isAgentsOrdersRoute()" -->
  @if (authServ.permissionUsed.value !== helpers.PermisionManufacturer) {
    <app-header></app-header>
  }
  <section
    [class.scrollableContainer]="
      !isAgentsOrdersRoute() &&
      !isLoginOrdersRoute() &&
      !isClientOrdersRoute() &&
      authServ.permissionUsed.value !== helpers.PermisionManufacturer
    "
    [class.manufacturer-shell]="
      authServ.permissionUsed.value === helpers.PermisionManufacturer
    "
  >
    <div
      class="main-content"
      [class.main-content]="!isMessageRoute()"
      [class.margin-right]="
        !isAgentsOrdersRoute() &&
        !isClientOrdersRoute() &&
        authServ.permissionUsed.value !== 4
      "
      [class.manufacturer-main-content]="
        authServ.permissionUsed.value === helpers.PermisionManufacturer
      "
      [class.page-left-offset]="!isWarehouseOrdersRoute()"
    >
      <router-outlet></router-outlet>
    </div>
  </section>
  <!-- <app-footer class="mt-auto"></app-footer> -->
</div>

<!--
  Modali globali app-level (v2.14.2):
  - credits-modal    → click sul logo Diakonix in sidebar
  - release-timeline → click sulla versione in sidebar
  - easter-egg-modal → keyboard-only (secretWord del maintainer)
-->
<app-credits-modal></app-credits-modal>
<app-release-timeline-modal></app-release-timeline-modal>
<app-easter-egg-modal></app-easter-egg-modal>
